import { useQuery } from '@tanstack/react-query';
import { usePermissions } from '@/contexts/PermissionsContext';
import { contactMessagesService } from '@/services/contactMessagesService';

export const CONTACT_UNREAD_COUNT_KEY = ['contact-unread-count'] as const;

/**
 * Nombre de messages Contact non lus (actualisé toutes les 60 s, pas de Realtime).
 * Désactivé sans la permission 'contact_messages' : aucune requête pour les autres utilisateurs.
 * En cas d'erreur : valeur indéfinie (le badge reste masqué), nouvel essai à l'intervalle suivant.
 */
export function useContactUnreadCount() {
  const { hasPermission, isLoading } = usePermissions();
  const allowed = !isLoading && hasPermission('contact_messages');

  const query = useQuery({
    queryKey: CONTACT_UNREAD_COUNT_KEY,
    queryFn: () => contactMessagesService.getUnreadCount(),
    enabled: allowed,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  return { allowed, count: query.data, isError: query.isError };
}
